import {
  CheckCircle,
  Clock,
  XCircle,
  AlertTriangle,
  Truck,
  CreditCard,
} from "lucide-react";

// Map issue status to Bootstrap badge classes
export const mapStatusToBootstrap = (status) => {
  switch (status?.toUpperCase()) {
    case "OPEN":
      return "badge bg-primary-subtle text-primary";
    case "CLOSED":
      return "badge bg-success-subtle text-success";
    case "PROCESSING":
      return "badge bg-info-subtle text-info";
    case "RESOLVED":
      return "badge bg-success-subtle text-success";
    case "INFO_REQUESTED":
    case "INFO_PROVIDED":
    case "INFO_NOT_AVAILABLE":
      return "badge bg-warning-subtle text-warning";
    case "RESOLUTION_PROPOSED":
    case "RESOLUTION_CASCADED":
    case "RESOLUTION_ACCEPTED":
    case "RESOLUTION_REJECTED":
      return "badge bg-info-subtle text-info";
    case "ESCALATED":
    case "CASCADED":
      return "badge bg-danger-subtle text-danger";
    default:
      return "badge bg-secondary-subtle text-secondary";
  }
};

// Map issue status to icons
export const getStatusIcon = (status) => {
  switch (status?.toUpperCase()) {
    case "OPEN":
    case "PROCESSING":
    case "RESOLUTION_PROPOSED":
      return <Clock size={14} />;
    case "CLOSED":
    case "RESOLVED":
    case "RESOLUTION_ACCEPTED":
      return <CheckCircle size={14} />;
    case "INFO_REQUESTED":
    case "INFO_PROVIDED":
    case "INFO_NOT_AVAILABLE":
    case "RESOLUTION_REJECTED":
      return <AlertTriangle size={14} />;
    case "ESCALATED":
    case "CASCADED":
      return <XCircle size={14} />;
    default:
      return <Clock size={14} />;
  }
};

// Map issue status/type to timeline dot colors
export const mapStatusToDotColor = (status) => {
  switch (status?.toUpperCase()) {
    case "OPEN":
      return "#0d6efd"; // bootstrap primary
    case "CLOSED":
      return "#198754"; // bootstrap success
    case "PROCESSING":
      return "#0dcaf0"; // bootstrap info
    case "RESOLVED":
      return "#198754"; // bootstrap success (matches badge)
    case "INFO_REQUESTED":
    case "INFO_PROVIDED":
    case "INFO_NOT_AVAILABLE":
      return "#ffc107"; // bootstrap warning
    case "RESOLUTION_PROPOSED":
    case "RESOLUTION_CASCADED":
    case "RESOLUTION_ACCEPTED":
    case "RESOLUTION_REJECTED":
      return "#0dcaf0"; // bootstrap info
    case "ESCALATED":
    case "CASCADED":
      return "#dc3545"; // bootstrap danger
    default:
      return "#6c757d"; // gray fallback
  }
};

// Other utility functions stay the same
export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(amount);



export const formatDateTime = (dateString) =>
  new Date(dateString).toLocaleString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

export const formatDuration = (duration) => {
  if (!duration) return "N/A";
  if (duration.includes("H")) {
    const hours = duration.match(/(\d+)H/)?.[1];
    return hours ? `${hours} Hour${hours > 1 ? "s" : ""}` : "N/A";
  }
  if (duration.includes("D")) {
    const days = duration.match(/(\d+)D/)?.[1];
    return days ? `${days} Day${days > 1 ? "s" : ""}` : "N/A";
  }
  return duration;
};

// Map action codes to labels and styling
export const actionMap = {
  OPEN: {
    type: "COMPLAINT OPENED",
    class: "complainant-action",
    defaultName: "Complainant",
    defaultContact: "N/A",
  },
  PROCESSING: {
    type: "PROCESSING",
    class: "respondent-action",
    defaultName: "Seller Support",
    defaultContact: "N/A",
  },
  INFO_REQUEST: {
    type: "INFO REQUESTED",
    class: "info-request",
    defaultName: "Support Team",
    defaultContact: "system",
  },
  RESOLVED: {
    type: "RESOLVED",
    class: "respondent-action",
    defaultName: "Support Team",
    defaultContact: "system",
  },
};

export const mapNotificationTypeToColor = (type) => {
  switch (type) {
    case "INFO_REQUESTED":
      return "bg-blue-100 text-blue-800";
    case "RESOLUTION_PROVIDED":
      return "bg-green-100 text-green-800";
    case "PENDING_ACTION":
      return "bg-yellow-100 text-yellow-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const formatLabel = (value = "") => {
  if (!value) return "-";
  return value
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};



